import styled from 'styled-components';
import { variables } from '../../../styles/variables';
export const InfoBarContainer = styled('ul')`
  display: flex;
  list-style: none;
  justify-content: space-between;
  padding-left: 0;
  li {
    flex: 0 0 24%;
    p {
      color: ${variables.colorMainText};
      font-size: 2rem;
      margin-bottom: 6px;
      &.header {
        font-weight: 700;
        line-height: 2.8rem;
      }
    }
  }
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
  @media (max-width: 667px) {
    li {
      flex: 0 0 50%;
    }
  }
`;